import React from 'react';
import { YStack, useTheme } from 'tamagui';

import CobuText from '../atoms/CobuText';
import { LinearGradient } from 'tamagui/linear-gradient';
import CobuButton from '../atoms/CobuButton';

interface CobuDisabledOverlayProps {
    onButtonPress: () => void;
    buttonText: string;
    disabled?: boolean;
    loading?: boolean;
    overlayText?: string;
    loadingText?: string;
}

const CobuDisabledOverlay: React.FC<CobuDisabledOverlayProps> = ({
    onButtonPress,
    buttonText,
    disabled = false,
    loading = false,
    overlayText,
    loadingText,
}) => {
    const theme = useTheme();

    const gradientColors: [string, string] = [
        'transparent', // Use transparent instead of hardcoded rgba
        theme.background?.val || theme.white?.val, // Use theme colors with fallback
    ];

    return (
        <YStack
            pos="absolute"
            t={0}
            l={0}
            r={0}
            b={0}
            jc="flex-end"
            ai="center"
            zi={10}
            pointerEvents="none"
        >
            <LinearGradient
                colors={gradientColors}
                start={{ x: 0, y: 0 }}
                end={{ x: 0, y: 1 }}
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                }}
            />

            <YStack
                w="100%"
                px="$4"
                pb="$6"
                ai="center"
                gap="$4"
                pointerEvents="auto"
            >
                <CobuText
                    variant="heading"
                    color="$cobuDarkBlue"
                    fontSize="$4"
                    fontWeight="bold"
                    ta="center"
                >
                    {overlayText}
                </CobuText>

                <YStack w="100%" px="$4">
                    <CobuButton
                        dsVariant="primary"
                        title={buttonText}
                        onPress={onButtonPress}
                        disabled={disabled}
                        loading={loading}
                        loadingText={loadingText}
                    />
                </YStack>
            </YStack>
        </YStack>
    );
};

export default CobuDisabledOverlay; 